import { render } from "./ProductProperty.vue?vue&type=template&id=913b2ee8&scoped=true&ts=true"
import script from "./ProductProperty.vue?vue&type=script&lang=ts"
export * from "./ProductProperty.vue?vue&type=script&lang=ts"

import "./ProductProperty.vue?vue&type=style&index=0&id=913b2ee8&lang=scss&scoped=true"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-913b2ee8"]])

export default __exports__